import { render, staticRenderFns } from "./KintaiPatternListPage.vue?vue&type=template&id=f8a8e796&scoped=true&"
import script from "./KintaiPatternListPage.vue?vue&type=script&lang=ts&"
export * from "./KintaiPatternListPage.vue?vue&type=script&lang=ts&"
import style0 from "./KintaiPatternListPage.vue?vue&type=style&index=0&id=f8a8e796&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f8a8e796",
  null
  
)

export default component.exports